import { useCallback, useMemo } from "react";

import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Context } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellLink from "ds/components/Table/Row/CellLink";

import useContextsAnalytics from "../../useContextsAnalytics";
import useCellCopyAction from "../useCellCopyAction";
import { CONTEXTS_COLUMN_ID } from "../constants";

const ContextsTableNameLinkCell = ({
  item: context,
  ...cellProps
}: TableSimpleCellProps<Context>) => {
  const trackAnalytics = useContextsAnalytics();

  const contextUrl = `/context/${context.id}`;

  const copyAction = useCellCopyAction({
    column: CONTEXTS_COLUMN_ID.NAME,
    text: context.name,
  });

  const handlePress = useCallback(() => {
    trackAnalytics("Name link clicked");
  }, [trackAnalytics]);

  const actions = useMemo(() => [copyAction], [copyAction]);

  return (
    <TableSimpleCell {...cellProps} actions={actions} role="rowheader">
      <TableCellLink href={contextUrl} onPress={handlePress}>
        {context.name}
      </TableCellLink>
    </TableSimpleCell>
  );
};

export default ContextsTableNameLinkCell;
